export const truncate = (str, n) => {
    return (str.length > n) ? str.substr(0, n-(n/2)) + '...' + str.substr(-(n/2), n-(n/2)) : str;
};